import { FeathersModel } from './feathersModel'

export class SocialService extends FeathersModel {
  static serviceName = 'social-services'

  socialServiceTypeId: number
  name: string
  description: string
  registeredSocialServiceNumber: string
  isArchived: boolean
}
